import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'core/context/TranslationContext';
import 'core/styles/public.css';

const COLUMNS = [
  {
    title: 'For candidates',
    links: [
      { to: '/jobs', label: 'Browse Jobs' },
      { to: '/cv', label: 'CV Builder' },
      { to: '/employers', label: 'Employers' },
      { to: '/signup', label: 'Create account' }
    ]
  },
  {
    title: 'For employers',
    links: [
      { to: '/candidates', label: 'Find candidates' },
      { to: '/signup', label: 'Post a job' },
      { to: '/login', label: 'Employer login' }
    ]
  },
  {
    title: 'Company',
    links: [
      { to: '/about', label: 'About us' },
      { to: '/contact', label: 'Contact' },
      { to: '/help', label: 'Help center' }
    ]
  }
];

function Footer() {
  const { _t } = useTranslation();

  return (
    <footer className="jf-public jf-footer">
      <div className="jf-container">
        <div className="jf-footer__top">
          <div className="jf-footer__brand">
            <Link to="/" className="jf-footer__logo"><img alt="Job Flow Connect" src="/assets/images/jlogo.png" /></Link>
            <p>
              {_t('Job Flow Connect is the heart of the career ecosystem and the premier platform to discover and connect with top professionals and opportunities worldwide.')}
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h6>{_t(col.title)}</h6>
              <ul>
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.to ? <Link to={l.to}>{_t(l.label)}</Link> : <a href={l.href}>{_t(l.label)}</a>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="jf-footer__bottom">
          <div>© {new Date().getFullYear()} <a href="https://jobflowconnect.com"><strong>JFC</strong></a>. {_t('All Rights Reserved')}</div>
          <nav>
            <Link to="/privacy">{_t('Privacy')}</Link>
            <Link to="/terms">{_t('Terms')}</Link>
            <Link to="/help">{_t('Help')}</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
